import { trackEvent } from './utils.js';

export function addNutritionToggle(el) {
  if(!el) {
  	return
  }
  const toggleBtn = document.querySelector('.nutrition-toggle')

  const overview = document.querySelector('.nutrition-overview')
  const list = document.querySelector('.nutrition-list')


  toggleBtn.addEventListener('click', (e)=> {
    overview.classList.toggle('show')
    if(!overview.classList.contains('show')) {
      trackEvent({ type: 'product', ev: 'get-nutrition-info', val: productName})
    }
    list.classList.toggle('show')
    toggleBtn.classList.toggle('open')
  })

}


// WEBPACK FOOTER //
// ./src/nutrition.js